import { render, staticRenderFns } from "./invoice.form.vue?vue&type=template&id=2d4b9ca6&"
import script from "./invoice.form.vue?vue&type=script&lang=js&"
export * from "./invoice.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports